import { render, staticRenderFns } from "./addproject.vue?vue&type=template&id=862e8830&"
import script from "./addproject.vue?vue&type=script&lang=js&"
export * from "./addproject.vue?vue&type=script&lang=js&"
import style0 from "./addproject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports